import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "dang_ky_chuong_trinh";

moduleApi.create = (dataForm) => { 
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm
  };
  return ApiService(api);
};

// moduleApi.update = (dataForm) => {
//   let api = {
//     module: moduleName,
//     type: "partialUpdate",
//     value: dataForm
//   };
//   return ApiService(api);
// };

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.delete = (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  return ApiService(api);
};

moduleApi.duyetThanhTichHuyHieu = (dang_ky_chuong_trinh_ids,huy_hieu_ids,loai_doi_tuong) => {
  let api = {
    module: moduleName,
    type: "duyet_thanh_tich_huy_hieu",    
    value: {
      dang_ky_chuong_trinh_ids: dang_ky_chuong_trinh_ids,
      huy_hieu_ids: huy_hieu_ids,
      loai_doi_tuong: loai_doi_tuong
    },
    message: {
      success: "Cấp huy hiệu thành công", //string | null | comment
      error: "",  //string | null | comment
    }

  };  
  return ApiService(api);
};

export default moduleApi;
